module.exports = __webpack_public_path__ + "img/youmu konpaku.b7514dd5.png";